var render = function render(){var _vm=this,_c=_vm._self._c;return _c('validated-input',{attrs:{"id":'digital-key-' + _vm._uid,"value":_vm.value,"idGtm":"claveDigital","validations":_vm.validations,"label":_vm.label,"quantumObfuscate":_vm.quantumObfuscate},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }